if (!customElements.get('countdown-timer')) {
	class CountdownTimer extends HTMLElement {
		constructor() {
			super()
			this.endDate = new Date(this.dataset.endDate).getTime()
			if (!Number(this.endDate)) return
			this.isCiclical = this.dataset.isCiclical == 'true'
			this.restart_hour = Number(this.dataset.endTime?.split(':')[0]) || 0
			this.restart_minute = Number(this.dataset.endTime?.split(':')[1]) || 0

			if (isNaN(this.restart_hour)) this.restart_hour = 0
			if (isNaN(this.restart_minute)) this.restart_minute = 0

			window.initLazyScript(this, this.init.bind(this))
		}

		init() {
			this.daysEl = this.querySelector('.js-days')
			this.hoursEl = this.querySelector('.js-hours')
			this.minsEl = this.querySelector('.js-mins')
			this.secsEl = this.querySelector('.js-secs')

			this.second = 1000
			this.minute = 60 * this.second
			this.hour = 60 * this.minute
			this.day = 24 * this.hour

			let targetDay = this.endDate

			if (this.isCiclical && this.dataset.restartDate) {
				targetDay = this.getNextDay(this.dataset.restartDate)
			}

			this.timer(targetDay)
			this.interval = setInterval(() => this.timer(targetDay), this.second)
		}

		timer(targetDay) {
			const timeDiff = targetDay - new Date()

			if (timeDiff < 0) {
				clearInterval(this.interval)
				return
			}

			const days = Math.floor(timeDiff / this.day)
			const hours = Math.floor(timeDiff / this.hour)
			const mins = Math.floor(timeDiff / this.minute)
			const secs = Math.floor(timeDiff / this.second)

			this.daysEl.textContent = days
			this.hoursEl.textContent = hours - days * 24
			this.minsEl.textContent = mins - hours * 60
			this.secsEl.textContent = secs - mins * 60
		}

		getNextDay(day) {
			const daysMap = {
				monday: 1,
				tuesday: 2,
				wednesday: 3,
				thursday: 4,
				friday: 5,
				saturday: 6,
				sunday: 7,
			}
			const today = new Date()
			const todayDay = today.getDay()
			const targetDay = daysMap[day.toLowerCase()]

			let daysUntilNext = (targetDay - todayDay + 7) % 7

			const nextDay = new Date(today)
			nextDay.setDate(today.getDate() + daysUntilNext)
			nextDay.setHours(this.restart_hour, this.restart_minute, 0, 0)
			return nextDay
		}
	}

	customElements.define('countdown-timer', CountdownTimer)
}
